import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppInitResolverService {
  private initResolver?: (value: any) => void;
  private initRejecter?: (reason?: any) => void;

  public setResolver(resolver: (value: any) => void, rejecter: (reason?: any) => void): void {
    this.initResolver = resolver;
    this.initRejecter = rejecter;
  }

  public resolveInit(): void {
    if (this.initResolver) {
      this.initResolver(true);
      this.initResolver = undefined;
      this.initRejecter = undefined;
    }
  }

  public rejectInit(error?: any): void {
    if (this.initRejecter) {
      this.initRejecter(error);
      this.initResolver = undefined;
      this.initRejecter = undefined;
    }
  }
}